{
  "en": {
    "сцена": "scene",
    "сцены": "scenes",
    "сцен": "scenes",
    "Свой набор": "Custom set",
    "Модель ИИ": "AI model",
    "Убираем фон · {0} из {1}": "Removing the background · {0} of {1}",
    "Фото {0} меньше {1} px по короткой стороне": "Photo {0} is under {1} px on the short side",
    "Фон убран · сам товар не меняем": "Background removed · the product itself stays unchanged",
    "Категория: {0}. Изменить": "Category: {0}. Change",
    "· изменить": "· change",
    "По площадке": "Platform format",
    "{0} · под {1}": "{0} · for {1}",
    "поровну на сцены": "split evenly across scenes",
    "{0} · без надписей на фото": "{0} · no text on the photos",
    "Например: мягкая тень, без реквизита": "For example: soft shadow, no props",
    "Без текста на фото": "No text on the photos",
    "Убираем фон, секунду": "Removing the background, one moment",
    "Добавьте фото того, кто в кадре": "Add photos of the person in the frame",
    "Сцены": "Scenes",
    "Свой набор: выбрать до {0} сцен": "Custom set: choose up to {0} scenes",
    "Выбрать сцены": "Choose scenes",
    "До {0} сцен": "Up to {0} scenes",
    "Наборы": "Sets",
    "Все сцены, {0}": "All scenes, {0}",
    "Модель ИИ: в наборе есть сцена с человеком": "AI model: the set has a scene with a person",
    "В наборе нужна хотя бы одна сцена": "A set needs at least one scene",
    "В одном наборе до {0} сцен": "Up to {0} scenes in one set",
    "Модель ИИ: в этой сцене есть человек": "AI model: this scene has a person",
    "Без модели: все кадры только с товаром": "No model: all frames show the product only",
    "{0} в кадрах по вашим фото": "{0} in the frames from your photos",
    "В сценах этой категории только товар, без людей": "Scenes of this category show the product only, no people",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "The set has no scenes with people: choose «With a model» or a custom set",
    "{0} во всех кадрах набора": "{0} in every frame of the set",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0} in {1} {2} of {3}, the rest show the product only",
    "кадре": "frame",
    "кадрах": "frames",
    "Сцены с человеком убрали из набора": "Scenes with a person were removed from the set",
    "Без модели: набор «Каталог»": "No model: «Catalog» set",
    "Набор «С моделью»: в нём есть сцены с людьми": "«With a model» set: it has scenes with people",
    "по {0} фото": "{0} photos each",
    "Искать среди {0} сцен · {1}": "Search {0} scenes · {1}",
    "Все сцены": "All scenes",
    "Сцена STEOS": "STEOS scene",
    ". В кадре: {0}": ". In the frame: {0}",
    "Пример {0}": "Example {0}",
    "О сцене": "About the scene",
    "вы": "you",
    "модель ИИ": "an AI model",
    "Убрать из набора": "Remove from the set",
    "Добавить в набор · {0}": "Add to the set · {0}",
    "Главный ракурс": "Main angle",
    "Ракурс {0}": "Angle {0}",
    "убираем фон": "removing the background",
    "фон убран": "background removed",
    "Без фона": "No background",
    "меньше": "under",
    "Сделать главным": "Make main",
    "Вырезка": "Cut-out",
    "Главное": "Main",
    "Фото {0}: проверить вырезку": "Photo {0}: check the cut-out",
    "Категория товара": "Product category",
    "Наборы и сцены под неё": "Sets and scenes for it",
    "Главное фото ·": "Main photo ·",
    "фото {0} из {1}": "photo {0} of {1}",
    "{0}, фото {1}": "{0}, photo {1}",
    "Ещё сцены": "More scenes",
    "модель: {0}": "model: {0}",
    "без модели": "no model",
    "Нужно фото товара: JPG или PNG": "A product photo is needed: JPG or PNG",
    "Пожелания не прошли проверку": "The wishes did not pass moderation",
    "Не получилось снять товар": "Could not shoot the product",
    "Изменить пожелания": "Edit the wishes",
    "Снимаем товар": "Shooting the product",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "You can leave the screen: the bot will send the photos to the chat as soon as the set is ready.",
    "Фото товара готовы": "Product photos are ready",
    "Не удалось открыть экран. Попробуйте ещё раз.": "Could not open the screen. Please try again.",
    "Загружаем сцены…": "Loading scenes…",
    "Готовим файлы в формате «{0}»": "Preparing files in the «{0}» format",
    "Готовим файлы под {0}": "Preparing files for {0}",
    "Убираем фон": "Removing the background",
    "Фон убран": "Background removed",
    "Снимаем сцены": "Shooting the scenes",
    "Сцены сняты": "Scenes shot",
    "По вашим фото": "From your photos",
    "{0} по вашим сценам": "{0} in your scenes",
    "сцене": "scene",
    "сценах": "scenes",
    "под {0}": "for {0}",
    "До 5 ракурсов, на любом фоне": "Up to 5 angles, on any background",
    "Свои фото сцен, до 9": "Your scene photos, up to 9",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "We will shoot the product in the same scenes: background, light, presentation. The product itself stays unchanged",
    "Каждое фото даст один кадр": "Each photo gives one frame",
    "не участвует в фотосессии товара": "is not in the product photo shoot",
    "Только для фотосессии товара": "Only for the product photo shoot",
    "Удалить из фотосессии товара": "Remove from the product photo shoot",
    "из фотосессии товара": "from the product photo shoot",
    "Сколько референсов, столько фото. Цена за кадр та же": "As many photos as references. The price per frame is the same",
    "Поиск сцен": "Search scenes",
    "Нажмите, чтобы добавить сцену": "Tap to add a scene"
  },
  "hy": {
    "сцена": "տեսարան",
    "сцены": "տեսարան",
    "сцен": "տեսարան",
    "Свой набор": "Սեփական հավաքածու",
    "Модель ИИ": "ԱԲ մոդել",
    "Убираем фон · {0} из {1}": "Հեռացնում ենք ֆոնը · {0}՝ {1}-ից",
    "Фото {0} меньше {1} px по короткой стороне": "Լուսանկար {0}-ը կարճ կողմով {1} px-ից փոքր է",
    "Фон убран · сам товар не меняем": "Ֆոնը հեռացված է · ապրանքն ինքը չենք փոխում",
    "Категория: {0}. Изменить": "Կատեգորիա՝ {0}։ Փոխել",
    "· изменить": "· փոխել",
    "По площадке": "Ըստ հարթակի",
    "{0} · под {1}": "{0} · {1}-ի համար",
    "поровну на сцены": "հավասարաչափ տեսարանների միջև",
    "{0} · без надписей на фото": "{0} · առանց գրությունների լուսանկարներին",
    "Например: мягкая тень, без реквизита": "Օրինակ՝ մեղմ ստվեր, առանց ռեկվիզիտի",
    "Без текста на фото": "Առանց տեքստի լուսանկարներին",
    "Убираем фон, секунду": "Հեռացնում ենք ֆոնը, մի պահ",
    "Добавьте фото того, кто в кадре": "Ավելացրեք կադրում գտնվողի լուսանկարները",
    "Сцены": "Տեսարաններ",
    "Свой набор: выбрать до {0} сцен": "Սեփական հավաքածու՝ ընտրել մինչև {0} տեսարան",
    "Выбрать сцены": "Ընտրել տեսարաններ",
    "До {0} сцен": "Մինչև {0} տեսարան",
    "Наборы": "Հավաքածուներ",
    "Все сцены, {0}": "Բոլոր տեսարանները, {0}",
    "Модель ИИ: в наборе есть сцена с человеком": "ԱԲ մոդել՝ հավաքածուում կա մարդով տեսարան",
    "В наборе нужна хотя бы одна сцена": "Հավաքածուում պետք է առնվազն մեկ տեսարան",
    "В одном наборе до {0} сцен": "Մեկ հավաքածուում մինչև {0} տեսարան",
    "Модель ИИ: в этой сцене есть человек": "ԱԲ մոդել՝ այս տեսարանում մարդ կա",
    "Без модели: все кадры только с товаром": "Առանց մոդելի՝ բոլոր կադրերում միայն ապրանքն է",
    "{0} в кадрах по вашим фото": "{0}՝ ձեր լուսանկարներով կադրերում",
    "В сценах этой категории только товар, без людей": "Այս կատեգորիայի տեսարաններում միայն ապրանքն է, առանց մարդկանց",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "Հավաքածուում մարդկանցով տեսարաններ չկան․ ընտրեք «Մոդելով» կամ սեփական հավաքածու",
    "{0} во всех кадрах набора": "{0}՝ հավաքածուի բոլոր կադրերում",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0}՝ {3}-ից {1} {2}, մնացածում միայն ապրանքն է",
    "кадре": "կադրում",
    "кадрах": "կադրում",
    "Сцены с человеком убрали из набора": "Մարդով տեսարանները հանվեցին հավաքածուից",
    "Без модели: набор «Каталог»": "Առանց մոդելի՝ «Կատալոգ» հավաքածու",
    "Набор «С моделью»: в нём есть сцены с людьми": "«Մոդելով» հավաքածու՝ այնտեղ կան մարդկանցով տեսարաններ",
    "по {0} фото": "{0}-ական լուսանկար",
    "Искать среди {0} сцен · {1}": "Որոնել {0} տեսարանում · {1}",
    "Все сцены": "Բոլոր տեսարանները",
    "Сцена STEOS": "STEOS տեսարան",
    ". В кадре: {0}": "։ Կադրում՝ {0}",
    "Пример {0}": "Օրինակ {0}",
    "О сцене": "Տեսարանի մասին",
    "вы": "դուք",
    "модель ИИ": "ԱԲ մոդել",
    "Убрать из набора": "Հանել հավաքածուից",
    "Добавить в набор · {0}": "Ավելացնել հավաքածուին · {0}",
    "Главный ракурс": "Հիմնական ռակուրս",
    "Ракурс {0}": "Ռակուրս {0}",
    "убираем фон": "հեռացնում ենք ֆոնը",
    "фон убран": "ֆոնը հեռացված է",
    "Без фона": "Առանց ֆոնի",
    "меньше": "փոքր",
    "Сделать главным": "Դարձնել հիմնական",
    "Вырезка": "Կտրվածք",
    "Главное": "Հիմնական",
    "Фото {0}: проверить вырезку": "Լուսանկար {0}՝ ստուգել կտրվածքը",
    "Категория товара": "Ապրանքի կատեգորիա",
    "Наборы и сцены под неё": "Հավաքածուներ և տեսարաններ դրա համար",
    "Главное фото ·": "Հիմնական լուսանկար ·",
    "фото {0} из {1}": "լուսանկար {0}՝ {1}-ից",
    "{0}, фото {1}": "{0}, լուսանկար {1}",
    "Ещё сцены": "Ավելի շատ տեսարաններ",
    "модель: {0}": "մոդել՝ {0}",
    "без модели": "առանց մոդելի",
    "Нужно фото товара: JPG или PNG": "Անհրաժեշտ է ապրանքի լուսանկար՝ JPG կամ PNG",
    "Пожелания не прошли проверку": "Ցանկությունները չանցան ստուգումը",
    "Не получилось снять товар": "Չհաջողվեց նկարահանել ապրանքը",
    "Изменить пожелания": "Փոխել ցանկությունները",
    "Снимаем товар": "Նկարահանում ենք ապրանքը",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "Կարող եք լքել էկրանը․ բոտը լուսանկարները կուղարկի չատ, հենց հավաքածուն պատրաստ լինի։",
    "Фото товара готовы": "Ապրանքի լուսանկարները պատրաստ են",
    "Не удалось открыть экран. Попробуйте ещё раз.": "Չհաջողվեց բացել էկրանը։ Փորձեք կրկին։",
    "Загружаем сцены…": "Բեռնում ենք տեսարանները…",
    "Готовим файлы в формате «{0}»": "Պատրաստում ենք ֆայլերը «{0}» ձևաչափով",
    "Готовим файлы под {0}": "Պատրաստում ենք ֆայլերը {0}-ի համար",
    "Убираем фон": "Հեռացնում ենք ֆոնը",
    "Фон убран": "Ֆոնը հեռացված է",
    "Снимаем сцены": "Նկարահանում ենք տեսարանները",
    "Сцены сняты": "Տեսարանները նկարահանված են",
    "По вашим фото": "Ձեր լուսանկարներով",
    "{0} по вашим сценам": "{0}՝ ձեր տեսարաններով",
    "сцене": "տեսարանում",
    "сценах": "տեսարանում",
    "под {0}": "{0}-ի համար",
    "До 5 ракурсов, на любом фоне": "Մինչև 5 ռակուրս, ցանկացած ֆոնի վրա",
    "Свои фото сцен, до 9": "Տեսարանների ձեր լուսանկարները, մինչև 9",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "Ապրանքը կնկարահանենք նույն տեսարաններում՝ ֆոն, լույս, մատուցում։ Ապրանքն ինքը չենք փոխում",
    "Каждое фото даст один кадр": "Յուրաքանչյուր լուսանկար կտա մեկ կադր",
    "не участвует в фотосессии товара": "չի մասնակցում ապրանքի ֆոտոսեսիային",
    "Только для фотосессии товара": "Միայն ապրանքի ֆոտոսեսիայի համար",
    "Удалить из фотосессии товара": "Հեռացնել ապրանքի ֆոտոսեսիայից",
    "из фотосессии товара": "ապրանքի ֆոտոսեսիայից",
    "Сколько референсов, столько фото. Цена за кадр та же": "Քանի օրինակելի պատկեր, այնքան լուսանկար։ Կադրի գինը նույնն է",
    "Поиск сцен": "Որոնել տեսարաններ",
    "Нажмите, чтобы добавить сцену": "Սեղմեք՝ տեսարան ավելացնելու համար"
  },
  "es": {
    "сцена": "escena",
    "сцены": "escenas",
    "сцен": "escenas",
    "Свой набор": "Set propio",
    "Модель ИИ": "Modelo IA",
    "Убираем фон · {0} из {1}": "Quitando el fondo · {0} de {1}",
    "Фото {0} меньше {1} px по короткой стороне": "La foto {0} mide menos de {1} px en el lado corto",
    "Фон убран · сам товар не меняем": "Fondo quitado · el producto no se modifica",
    "Категория: {0}. Изменить": "Categoría: {0}. Cambiar",
    "· изменить": "· cambiar",
    "По площадке": "Según la plataforma",
    "{0} · под {1}": "{0} · para {1}",
    "поровну на сцены": "repartidas por igual entre escenas",
    "{0} · без надписей на фото": "{0} · sin texto en las fotos",
    "Например: мягкая тень, без реквизита": "Por ejemplo: sombra suave, sin atrezo",
    "Без текста на фото": "Sin texto en las fotos",
    "Убираем фон, секунду": "Quitando el fondo, un momento",
    "Добавьте фото того, кто в кадре": "Añade fotos de quien aparece en la imagen",
    "Сцены": "Escenas",
    "Свой набор: выбрать до {0} сцен": "Set propio: elige hasta {0} escenas",
    "Выбрать сцены": "Elegir escenas",
    "До {0} сцен": "Hasta {0} escenas",
    "Наборы": "Sets",
    "Все сцены, {0}": "Todas las escenas, {0}",
    "Модель ИИ: в наборе есть сцена с человеком": "Modelo IA: el set tiene una escena con una persona",
    "В наборе нужна хотя бы одна сцена": "El set necesita al menos una escena",
    "В одном наборе до {0} сцен": "Hasta {0} escenas por set",
    "Модель ИИ: в этой сцене есть человек": "Modelo IA: esta escena tiene una persona",
    "Без модели: все кадры только с товаром": "Sin modelo: todas las tomas solo con el producto",
    "{0} в кадрах по вашим фото": "{0} en las tomas de tus fotos",
    "В сценах этой категории только товар, без людей": "Las escenas de esta categoría son solo con el producto, sin personas",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "El set no tiene escenas con personas: elige «Con modelo» o un set propio",
    "{0} во всех кадрах набора": "{0} en todas las tomas del set",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0} en {1} {2} de {3}, el resto solo con el producto",
    "кадре": "toma",
    "кадрах": "tomas",
    "Сцены с человеком убрали из набора": "Quitamos del set las escenas con personas",
    "Без модели: набор «Каталог»": "Sin modelo: set «Catálogo»",
    "Набор «С моделью»: в нём есть сцены с людьми": "Set «Con modelo»: tiene escenas con personas",
    "по {0} фото": "{0} fotos cada una",
    "Искать среди {0} сцен · {1}": "Buscar entre {0} escenas · {1}",
    "Все сцены": "Todas las escenas",
    "Сцена STEOS": "Escena STEOS",
    ". В кадре: {0}": ". En la imagen: {0}",
    "Пример {0}": "Ejemplo {0}",
    "О сцене": "Sobre la escena",
    "вы": "tú",
    "модель ИИ": "un modelo IA",
    "Убрать из набора": "Quitar del set",
    "Добавить в набор · {0}": "Añadir al set · {0}",
    "Главный ракурс": "Ángulo principal",
    "Ракурс {0}": "Ángulo {0}",
    "убираем фон": "quitando el fondo",
    "фон убран": "fondo quitado",
    "Без фона": "Sin fondo",
    "меньше": "menos de",
    "Сделать главным": "Hacer principal",
    "Вырезка": "Recorte",
    "Главное": "Principal",
    "Фото {0}: проверить вырезку": "Foto {0}: revisar el recorte",
    "Категория товара": "Categoría del producto",
    "Наборы и сцены под неё": "Sets y escenas para ella",
    "Главное фото ·": "Foto principal ·",
    "фото {0} из {1}": "foto {0} de {1}",
    "{0}, фото {1}": "{0}, foto {1}",
    "Ещё сцены": "Más escenas",
    "модель: {0}": "modelo: {0}",
    "без модели": "sin modelo",
    "Нужно фото товара: JPG или PNG": "Se necesita una foto del producto: JPG o PNG",
    "Пожелания не прошли проверку": "Las indicaciones no pasaron la revisión",
    "Не получилось снять товар": "No se pudo fotografiar el producto",
    "Изменить пожелания": "Cambiar las indicaciones",
    "Снимаем товар": "Fotografiando el producto",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "Puedes salir de la pantalla: el bot enviará las fotos al chat en cuanto el set esté listo.",
    "Фото товара готовы": "Las fotos del producto están listas",
    "Не удалось открыть экран. Попробуйте ещё раз.": "No se pudo abrir la pantalla. Inténtalo de nuevo.",
    "Загружаем сцены…": "Cargando escenas…",
    "Готовим файлы в формате «{0}»": "Preparando archivos en formato «{0}»",
    "Готовим файлы под {0}": "Preparando archivos para {0}",
    "Убираем фон": "Quitando el fondo",
    "Фон убран": "Fondo quitado",
    "Снимаем сцены": "Rodando las escenas",
    "Сцены сняты": "Escenas rodadas",
    "По вашим фото": "Según tus fotos",
    "{0} по вашим сценам": "{0} en tus escenas",
    "сцене": "escena",
    "сценах": "escenas",
    "под {0}": "para {0}",
    "До 5 ракурсов, на любом фоне": "Hasta 5 ángulos, sobre cualquier fondo",
    "Свои фото сцен, до 9": "Tus fotos de escenas, hasta 9",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "Fotografiaremos el producto en escenas iguales: fondo, luz, presentación. El producto no se modifica",
    "Каждое фото даст один кадр": "Cada foto da una toma",
    "не участвует в фотосессии товара": "no participa en la sesión de fotos del producto",
    "Только для фотосессии товара": "Solo para la sesión de fotos del producto",
    "Удалить из фотосессии товара": "Quitar de la sesión de fotos del producto",
    "из фотосессии товара": "de la sesión de fotos del producto",
    "Сколько референсов, столько фото. Цена за кадр та же": "Tantas fotos como referencias. El precio por toma es el mismo",
    "Поиск сцен": "Buscar escenas",
    "Нажмите, чтобы добавить сцену": "Toca para añadir una escena"
  },
  "de": {
    "сцена": "Szene",
    "сцены": "Szenen",
    "сцен": "Szenen",
    "Свой набор": "Eigenes Set",
    "Модель ИИ": "KI-Model",
    "Убираем фон · {0} из {1}": "Hintergrund wird entfernt · {0} von {1}",
    "Фото {0} меньше {1} px по короткой стороне": "Foto {0} ist an der kurzen Seite kleiner als {1} px",
    "Фон убран · сам товар не меняем": "Hintergrund entfernt · das Produkt selbst bleibt unverändert",
    "Категория: {0}. Изменить": "Kategorie: {0}. Ändern",
    "· изменить": "· ändern",
    "По площадке": "Nach Plattform",
    "{0} · под {1}": "{0} · für {1}",
    "поровну на сцены": "gleichmäßig auf die Szenen verteilt",
    "{0} · без надписей на фото": "{0} · ohne Text auf den Fotos",
    "Например: мягкая тень, без реквизита": "Zum Beispiel: weicher Schatten, keine Requisiten",
    "Без текста на фото": "Kein Text auf den Fotos",
    "Убираем фон, секунду": "Hintergrund wird entfernt, einen Moment",
    "Добавьте фото того, кто в кадре": "Fügen Sie Fotos der Person im Bild hinzu",
    "Сцены": "Szenen",
    "Свой набор: выбрать до {0} сцен": "Eigenes Set: bis zu {0} Szenen wählen",
    "Выбрать сцены": "Szenen wählen",
    "До {0} сцен": "Bis zu {0} Szenen",
    "Наборы": "Sets",
    "Все сцены, {0}": "Alle Szenen, {0}",
    "Модель ИИ: в наборе есть сцена с человеком": "KI-Model: Das Set enthält eine Szene mit einer Person",
    "В наборе нужна хотя бы одна сцена": "Ein Set braucht mindestens eine Szene",
    "В одном наборе до {0} сцен": "Bis zu {0} Szenen pro Set",
    "Модель ИИ: в этой сцене есть человек": "KI-Model: In dieser Szene ist eine Person",
    "Без модели: все кадры только с товаром": "Ohne Model: alle Bilder nur mit dem Produkt",
    "{0} в кадрах по вашим фото": "{0} in den Bildern nach Ihren Fotos",
    "В сценах этой категории только товар, без людей": "Die Szenen dieser Kategorie zeigen nur das Produkt, ohne Personen",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "Das Set enthält keine Szenen mit Personen: Wählen Sie «Mit Model» oder ein eigenes Set",
    "{0} во всех кадрах набора": "{0} in allen Bildern des Sets",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0} in {1} {2} von {3}, die übrigen nur mit dem Produkt",
    "кадре": "Bild",
    "кадрах": "Bildern",
    "Сцены с человеком убрали из набора": "Szenen mit Personen wurden aus dem Set entfernt",
    "Без модели: набор «Каталог»": "Ohne Model: Set «Katalog»",
    "Набор «С моделью»: в нём есть сцены с людьми": "Set «Mit Model»: Es enthält Szenen mit Personen",
    "по {0} фото": "je {0} Fotos",
    "Искать среди {0} сцен · {1}": "In {0} Szenen suchen · {1}",
    "Все сцены": "Alle Szenen",
    "Сцена STEOS": "STEOS-Szene",
    ". В кадре: {0}": ". Im Bild: {0}",
    "Пример {0}": "Beispiel {0}",
    "О сцене": "Über die Szene",
    "вы": "Sie",
    "модель ИИ": "ein KI-Model",
    "Убрать из набора": "Aus dem Set entfernen",
    "Добавить в набор · {0}": "Zum Set hinzufügen · {0}",
    "Главный ракурс": "Hauptperspektive",
    "Ракурс {0}": "Perspektive {0}",
    "убираем фон": "Hintergrund wird entfernt",
    "фон убран": "Hintergrund entfernt",
    "Без фона": "Ohne Hintergrund",
    "меньше": "kleiner als",
    "Сделать главным": "Als Hauptfoto",
    "Вырезка": "Freisteller",
    "Главное": "Hauptfoto",
    "Фото {0}: проверить вырезку": "Foto {0}: Freisteller prüfen",
    "Категория товара": "Produktkategorie",
    "Наборы и сцены под неё": "Sets und Szenen dafür",
    "Главное фото ·": "Hauptfoto ·",
    "фото {0} из {1}": "Foto {0} von {1}",
    "{0}, фото {1}": "{0}, Foto {1}",
    "Ещё сцены": "Weitere Szenen",
    "модель: {0}": "Model: {0}",
    "без модели": "ohne Model",
    "Нужно фото товара: JPG или PNG": "Ein Produktfoto wird benötigt: JPG oder PNG",
    "Пожелания не прошли проверку": "Die Wünsche haben die Prüfung nicht bestanden",
    "Не получилось снять товар": "Das Produkt konnte nicht fotografiert werden",
    "Изменить пожелания": "Wünsche ändern",
    "Снимаем товар": "Produkt wird fotografiert",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "Sie können den Bildschirm verlassen: Der Bot schickt die Fotos in den Chat, sobald das Set fertig ist.",
    "Фото товара готовы": "Die Produktfotos sind fertig",
    "Не удалось открыть экран. Попробуйте ещё раз.": "Der Bildschirm konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.",
    "Загружаем сцены…": "Szenen werden geladen…",
    "Готовим файлы в формате «{0}»": "Dateien im Format «{0}» werden vorbereitet",
    "Готовим файлы под {0}": "Dateien für {0} werden vorbereitet",
    "Убираем фон": "Hintergrund wird entfernt",
    "Фон убран": "Hintergrund entfernt",
    "Снимаем сцены": "Szenen werden gedreht",
    "Сцены сняты": "Szenen gedreht",
    "По вашим фото": "Nach Ihren Fotos",
    "{0} по вашим сценам": "{0} in Ihren Szenen",
    "сцене": "Szene",
    "сценах": "Szenen",
    "под {0}": "für {0}",
    "До 5 ракурсов, на любом фоне": "Bis zu 5 Perspektiven, auf beliebigem Hintergrund",
    "Свои фото сцен, до 9": "Eigene Szenenfotos, bis zu 9",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "Wir fotografieren das Produkt in den gleichen Szenen: Hintergrund, Licht, Präsentation. Das Produkt selbst bleibt unverändert",
    "Каждое фото даст один кадр": "Jedes Foto ergibt ein Bild",
    "не участвует в фотосессии товара": "ist nicht im Produktfotoshooting",
    "Только для фотосессии товара": "Nur für das Produktfotoshooting",
    "Удалить из фотосессии товара": "Aus dem Produktfotoshooting entfernen",
    "из фотосессии товара": "aus dem Produktfotoshooting",
    "Сколько референсов, столько фото. Цена за кадр та же": "So viele Fotos wie Referenzen. Der Preis pro Bild bleibt gleich",
    "Поиск сцен": "Szenen suchen",
    "Нажмите, чтобы добавить сцену": "Tippen Sie, um eine Szene hinzuzufügen"
  },
  "fr": {
    "сцена": "scène",
    "сцены": "scènes",
    "сцен": "scènes",
    "Свой набор": "Votre sélection",
    "Модель ИИ": "Modèle IA",
    "Убираем фон · {0} из {1}": "Suppression du fond · {0} sur {1}",
    "Фото {0} меньше {1} px по короткой стороне": "La photo {0} fait moins de {1} px sur le petit côté",
    "Фон убран · сам товар не меняем": "Fond supprimé · le produit lui-même reste intact",
    "Категория: {0}. Изменить": "Catégorie : {0}. Modifier",
    "· изменить": "· modifier",
    "По площадке": "Selon la plateforme",
    "{0} · под {1}": "{0} · pour {1}",
    "поровну на сцены": "réparties à parts égales entre les scènes",
    "{0} · без надписей на фото": "{0} · sans texte sur les photos",
    "Например: мягкая тень, без реквизита": "Par exemple : ombre douce, sans accessoires",
    "Без текста на фото": "Pas de texte sur les photos",
    "Убираем фон, секунду": "Suppression du fond, un instant",
    "Добавьте фото того, кто в кадре": "Ajoutez des photos de la personne dans le cadre",
    "Сцены": "Scènes",
    "Свой набор: выбрать до {0} сцен": "Votre sélection : choisissez jusqu’à {0} scènes",
    "Выбрать сцены": "Choisir les scènes",
    "До {0} сцен": "Jusqu’à {0} scènes",
    "Наборы": "Sélections",
    "Все сцены, {0}": "Toutes les scènes, {0}",
    "Модель ИИ: в наборе есть сцена с человеком": "Modèle IA : la sélection contient une scène avec une personne",
    "В наборе нужна хотя бы одна сцена": "Une sélection doit contenir au moins une scène",
    "В одном наборе до {0} сцен": "Jusqu’à {0} scènes par sélection",
    "Модель ИИ: в этой сцене есть человек": "Modèle IA : cette scène comporte une personne",
    "Без модели: все кадры только с товаром": "Sans modèle : toutes les prises avec le produit seul",
    "{0} в кадрах по вашим фото": "{0} dans les prises d’après vos photos",
    "В сценах этой категории только товар, без людей": "Les scènes de cette catégorie montrent le produit seul, sans personne",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "La sélection n’a pas de scènes avec des personnes : choisissez «Avec modèle» ou votre sélection",
    "{0} во всех кадрах набора": "{0} dans toutes les prises de la sélection",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0} dans {1} {2} sur {3}, les autres avec le produit seul",
    "кадре": "prise",
    "кадрах": "prises",
    "Сцены с человеком убрали из набора": "Les scènes avec une personne ont été retirées de la sélection",
    "Без модели: набор «Каталог»": "Sans modèle : sélection «Catalogue»",
    "Набор «С моделью»: в нём есть сцены с людьми": "Sélection «Avec modèle» : elle contient des scènes avec des personnes",
    "по {0} фото": "{0} photos chacune",
    "Искать среди {0} сцен · {1}": "Rechercher parmi {0} scènes · {1}",
    "Все сцены": "Toutes les scènes",
    "Сцена STEOS": "Scène STEOS",
    ". В кадре: {0}": ". Dans le cadre : {0}",
    "Пример {0}": "Exemple {0}",
    "О сцене": "À propos de la scène",
    "вы": "vous",
    "модель ИИ": "un modèle IA",
    "Убрать из набора": "Retirer de la sélection",
    "Добавить в набор · {0}": "Ajouter à la sélection · {0}",
    "Главный ракурс": "Angle principal",
    "Ракурс {0}": "Angle {0}",
    "убираем фон": "suppression du fond",
    "фон убран": "fond supprimé",
    "Без фона": "Sans fond",
    "меньше": "moins de",
    "Сделать главным": "Définir comme principale",
    "Вырезка": "Détourage",
    "Главное": "Principale",
    "Фото {0}: проверить вырезку": "Photo {0} : vérifier le détourage",
    "Категория товара": "Catégorie du produit",
    "Наборы и сцены под неё": "Sélections et scènes adaptées",
    "Главное фото ·": "Photo principale ·",
    "фото {0} из {1}": "photo {0} sur {1}",
    "{0}, фото {1}": "{0}, photo {1}",
    "Ещё сцены": "Plus de scènes",
    "модель: {0}": "modèle : {0}",
    "без модели": "sans modèle",
    "Нужно фото товара: JPG или PNG": "Une photo du produit est nécessaire : JPG ou PNG",
    "Пожелания не прошли проверку": "Les souhaits n’ont pas passé la vérification",
    "Не получилось снять товар": "Impossible de photographier le produit",
    "Изменить пожелания": "Modifier les souhaits",
    "Снимаем товар": "Prise de vue du produit",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "Vous pouvez quitter l’écran : le bot enverra les photos dans le chat dès que la série sera prête.",
    "Фото товара готовы": "Les photos du produit sont prêtes",
    "Не удалось открыть экран. Попробуйте ещё раз.": "Impossible d’ouvrir l’écran. Réessayez.",
    "Загружаем сцены…": "Chargement des scènes…",
    "Готовим файлы в формате «{0}»": "Préparation des fichiers au format «{0}»",
    "Готовим файлы под {0}": "Préparation des fichiers pour {0}",
    "Убираем фон": "Suppression du fond",
    "Фон убран": "Fond supprimé",
    "Снимаем сцены": "Tournage des scènes",
    "Сцены сняты": "Scènes tournées",
    "По вашим фото": "D’après vos photos",
    "{0} по вашим сценам": "{0} dans vos scènes",
    "сцене": "scène",
    "сценах": "scènes",
    "под {0}": "pour {0}",
    "До 5 ракурсов, на любом фоне": "Jusqu’à 5 angles, sur n’importe quel fond",
    "Свои фото сцен, до 9": "Vos photos de scènes, jusqu’à 9",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "Nous photographierons le produit dans les mêmes scènes : fond, lumière, mise en scène. Le produit lui-même reste intact",
    "Каждое фото даст один кадр": "Chaque photo donne une prise",
    "не участвует в фотосессии товара": "ne participe pas à la séance photo du produit",
    "Только для фотосессии товара": "Uniquement pour la séance photo du produit",
    "Удалить из фотосессии товара": "Retirer de la séance photo du produit",
    "из фотосессии товара": "de la séance photo du produit",
    "Сколько референсов, столько фото. Цена за кадр та же": "Autant de photos que de références. Le prix par prise reste le même",
    "Поиск сцен": "Rechercher des scènes",
    "Нажмите, чтобы добавить сцену": "Touchez pour ajouter une scène"
  },
  "pt": {
    "сцена": "cena",
    "сцены": "cenas",
    "сцен": "cenas",
    "Свой набор": "Conjunto próprio",
    "Модель ИИ": "Modelo IA",
    "Убираем фон · {0} из {1}": "Removendo o fundo · {0} de {1}",
    "Фото {0} меньше {1} px по короткой стороне": "A foto {0} tem menos de {1} px no lado menor",
    "Фон убран · сам товар не меняем": "Fundo removido · o produto em si não é alterado",
    "Категория: {0}. Изменить": "Categoria: {0}. Alterar",
    "· изменить": "· alterar",
    "По площадке": "Conforme a plataforma",
    "{0} · под {1}": "{0} · para {1}",
    "поровну на сцены": "divididas igualmente entre as cenas",
    "{0} · без надписей на фото": "{0} · sem texto nas fotos",
    "Например: мягкая тень, без реквизита": "Por exemplo: sombra suave, sem objetos de cena",
    "Без текста на фото": "Sem texto nas fotos",
    "Убираем фон, секунду": "Removendo o fundo, um momento",
    "Добавьте фото того, кто в кадре": "Adicione fotos de quem está no quadro",
    "Сцены": "Cenas",
    "Свой набор: выбрать до {0} сцен": "Conjunto próprio: escolha até {0} cenas",
    "Выбрать сцены": "Escolher cenas",
    "До {0} сцен": "Até {0} cenas",
    "Наборы": "Conjuntos",
    "Все сцены, {0}": "Todas as cenas, {0}",
    "Модель ИИ: в наборе есть сцена с человеком": "Modelo IA: o conjunto tem uma cena com uma pessoa",
    "В наборе нужна хотя бы одна сцена": "O conjunto precisa de pelo menos uma cena",
    "В одном наборе до {0} сцен": "Até {0} cenas por conjunto",
    "Модель ИИ: в этой сцене есть человек": "Modelo IA: esta cena tem uma pessoa",
    "Без модели: все кадры только с товаром": "Sem modelo: todas as fotos só com o produto",
    "{0} в кадрах по вашим фото": "{0} nas fotos baseadas nas suas",
    "В сценах этой категории только товар, без людей": "As cenas desta categoria mostram só o produto, sem pessoas",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "O conjunto não tem cenas com pessoas: escolha «Com modelo» ou um conjunto próprio",
    "{0} во всех кадрах набора": "{0} em todas as fotos do conjunto",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0} em {1} {2} de {3}, as demais só com o produto",
    "кадре": "foto",
    "кадрах": "fotos",
    "Сцены с человеком убрали из набора": "As cenas com pessoas foram removidas do conjunto",
    "Без модели: набор «Каталог»": "Sem modelo: conjunto «Catálogo»",
    "Набор «С моделью»: в нём есть сцены с людьми": "Conjunto «Com modelo»: tem cenas com pessoas",
    "по {0} фото": "{0} fotos cada",
    "Искать среди {0} сцен · {1}": "Buscar entre {0} cenas · {1}",
    "Все сцены": "Todas as cenas",
    "Сцена STEOS": "Cena STEOS",
    ". В кадре: {0}": ". No quadro: {0}",
    "Пример {0}": "Exemplo {0}",
    "О сцене": "Sobre a cena",
    "вы": "você",
    "модель ИИ": "um modelo IA",
    "Убрать из набора": "Remover do conjunto",
    "Добавить в набор · {0}": "Adicionar ao conjunto · {0}",
    "Главный ракурс": "Ângulo principal",
    "Ракурс {0}": "Ângulo {0}",
    "убираем фон": "removendo o fundo",
    "фон убран": "fundo removido",
    "Без фона": "Sem fundo",
    "меньше": "menos de",
    "Сделать главным": "Tornar principal",
    "Вырезка": "Recorte",
    "Главное": "Principal",
    "Фото {0}: проверить вырезку": "Foto {0}: verificar o recorte",
    "Категория товара": "Categoria do produto",
    "Наборы и сцены под неё": "Conjuntos e cenas para ela",
    "Главное фото ·": "Foto principal ·",
    "фото {0} из {1}": "foto {0} de {1}",
    "{0}, фото {1}": "{0}, foto {1}",
    "Ещё сцены": "Mais cenas",
    "модель: {0}": "modelo: {0}",
    "без модели": "sem modelo",
    "Нужно фото товара: JPG или PNG": "É preciso uma foto do produto: JPG ou PNG",
    "Пожелания не прошли проверку": "Os pedidos não passaram na verificação",
    "Не получилось снять товар": "Não foi possível fotografar o produto",
    "Изменить пожелания": "Alterar os pedidos",
    "Снимаем товар": "Fotografando o produto",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "Você pode sair da tela: o bot enviará as fotos para o chat assim que o conjunto estiver pronto.",
    "Фото товара готовы": "As fotos do produto estão prontas",
    "Не удалось открыть экран. Попробуйте ещё раз.": "Não foi possível abrir a tela. Tente novamente.",
    "Загружаем сцены…": "Carregando cenas…",
    "Готовим файлы в формате «{0}»": "Preparando arquivos no formato «{0}»",
    "Готовим файлы под {0}": "Preparando arquivos para {0}",
    "Убираем фон": "Removendo o fundo",
    "Фон убран": "Fundo removido",
    "Снимаем сцены": "Gravando as cenas",
    "Сцены сняты": "Cenas gravadas",
    "По вашим фото": "Com base nas suas fotos",
    "{0} по вашим сценам": "{0} nas suas cenas",
    "сцене": "cena",
    "сценах": "cenas",
    "под {0}": "para {0}",
    "До 5 ракурсов, на любом фоне": "Até 5 ângulos, em qualquer fundo",
    "Свои фото сцен, до 9": "Suas fotos de cenas, até 9",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "Fotografaremos o produto nas mesmas cenas: fundo, luz, apresentação. O produto em si não é alterado",
    "Каждое фото даст один кадр": "Cada foto gera uma imagem",
    "не участвует в фотосессии товара": "não participa da sessão de fotos do produto",
    "Только для фотосессии товара": "Só para a sessão de fotos do produto",
    "Удалить из фотосессии товара": "Remover da sessão de fotos do produto",
    "из фотосессии товара": "da sessão de fotos do produto",
    "Сколько референсов, столько фото. Цена за кадр та же": "Tantas fotos quanto referências. O preço por foto é o mesmo",
    "Поиск сцен": "Buscar cenas",
    "Нажмите, чтобы добавить сцену": "Toque para adicionar uma cena"
  },
  "tr": {
    "сцена": "sahne",
    "сцены": "sahne",
    "сцен": "sahne",
    "Свой набор": "Kendi setiniz",
    "Модель ИИ": "Yapay zekâ modeli",
    "Убираем фон · {0} из {1}": "Arka plan kaldırılıyor · {0}/{1}",
    "Фото {0} меньше {1} px по короткой стороне": "Fotoğraf {0} kısa kenarda {1} px’ten küçük",
    "Фон убран · сам товар не меняем": "Arka plan kaldırıldı · ürünün kendisi değişmez",
    "Категория: {0}. Изменить": "Kategori: {0}. Değiştir",
    "· изменить": "· değiştir",
    "По площадке": "Platforma göre",
    "{0} · под {1}": "{0} · {1} için",
    "поровну на сцены": "sahnelere eşit dağıtılır",
    "{0} · без надписей на фото": "{0} · fotoğraflarda yazı yok",
    "Например: мягкая тень, без реквизита": "Örneğin: yumuşak gölge, dekor yok",
    "Без текста на фото": "Fotoğraflarda yazı yok",
    "Убираем фон, секунду": "Arka plan kaldırılıyor, bir saniye",
    "Добавьте фото того, кто в кадре": "Karedeki kişinin fotoğraflarını ekleyin",
    "Сцены": "Sahneler",
    "Свой набор: выбрать до {0} сцен": "Kendi setiniz: en fazla {0} sahne seçin",
    "Выбрать сцены": "Sahne seç",
    "До {0} сцен": "En fazla {0} sahne",
    "Наборы": "Setler",
    "Все сцены, {0}": "Tüm sahneler, {0}",
    "Модель ИИ: в наборе есть сцена с человеком": "Yapay zekâ modeli: sette insanlı bir sahne var",
    "В наборе нужна хотя бы одна сцена": "Sette en az bir sahne olmalı",
    "В одном наборе до {0} сцен": "Bir sette en fazla {0} sahne",
    "Модель ИИ: в этой сцене есть человек": "Yapay zekâ modeli: bu sahnede bir insan var",
    "Без модели: все кадры только с товаром": "Modelsiz: tüm karelerde yalnızca ürün",
    "{0} в кадрах по вашим фото": "{0}, fotoğraflarınıza göre karelerde",
    "В сценах этой категории только товар, без людей": "Bu kategorinin sahnelerinde yalnızca ürün var, insan yok",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "Sette insanlı sahne yok: «Modelli» veya kendi setinizi seçin",
    "{0} во всех кадрах набора": "{0}, setin tüm karelerinde",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0}, {3} karenin {1} {2}, diğerlerinde yalnızca ürün",
    "кадре": "karesinde",
    "кадрах": "karesinde",
    "Сцены с человеком убрали из набора": "İnsanlı sahneler setten çıkarıldı",
    "Без модели: набор «Каталог»": "Modelsiz: «Katalog» seti",
    "Набор «С моделью»: в нём есть сцены с людьми": "«Modelli» set: insanlı sahneler içerir",
    "по {0} фото": "her birine {0} fotoğraf",
    "Искать среди {0} сцен · {1}": "{0} sahnede ara · {1}",
    "Все сцены": "Tüm sahneler",
    "Сцена STEOS": "STEOS sahnesi",
    ". В кадре: {0}": ". Karede: {0}",
    "Пример {0}": "Örnek {0}",
    "О сцене": "Sahne hakkında",
    "вы": "siz",
    "модель ИИ": "yapay zekâ modeli",
    "Убрать из набора": "Setten çıkar",
    "Добавить в набор · {0}": "Sete ekle · {0}",
    "Главный ракурс": "Ana açı",
    "Ракурс {0}": "Açı {0}",
    "убираем фон": "arka plan kaldırılıyor",
    "фон убран": "arka plan kaldırıldı",
    "Без фона": "Arka plansız",
    "меньше": "şundan küçük:",
    "Сделать главным": "Ana yap",
    "Вырезка": "Kesim",
    "Главное": "Ana",
    "Фото {0}: проверить вырезку": "Fotoğraf {0}: kesimi kontrol et",
    "Категория товара": "Ürün kategorisi",
    "Наборы и сцены под неё": "Ona uygun setler ve sahneler",
    "Главное фото ·": "Ana fotoğraf ·",
    "фото {0} из {1}": "fotoğraf {0}/{1}",
    "{0}, фото {1}": "{0}, fotoğraf {1}",
    "Ещё сцены": "Daha fazla sahne",
    "модель: {0}": "model: {0}",
    "без модели": "modelsiz",
    "Нужно фото товара: JPG или PNG": "Ürün fotoğrafı gerekli: JPG veya PNG",
    "Пожелания не прошли проверку": "İstekler denetimden geçmedi",
    "Не получилось снять товар": "Ürün çekilemedi",
    "Изменить пожелания": "İstekleri değiştir",
    "Снимаем товар": "Ürün çekiliyor",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "Ekrandan çıkabilirsiniz: set hazır olur olmaz bot fotoğrafları sohbete gönderecek.",
    "Фото товара готовы": "Ürün fotoğrafları hazır",
    "Не удалось открыть экран. Попробуйте ещё раз.": "Ekran açılamadı. Tekrar deneyin.",
    "Загружаем сцены…": "Sahneler yükleniyor…",
    "Готовим файлы в формате «{0}»": "Dosyalar «{0}» biçiminde hazırlanıyor",
    "Готовим файлы под {0}": "Dosyalar {0} için hazırlanıyor",
    "Убираем фон": "Arka plan kaldırılıyor",
    "Фон убран": "Arka plan kaldırıldı",
    "Снимаем сцены": "Sahneler çekiliyor",
    "Сцены сняты": "Sahneler çekildi",
    "По вашим фото": "Fotoğraflarınıza göre",
    "{0} по вашим сценам": "{0}, sahnelerinize göre",
    "сцене": "sahnede",
    "сценах": "sahnede",
    "под {0}": "{0} için",
    "До 5 ракурсов, на любом фоне": "Herhangi bir arka planda en fazla 5 açı",
    "Свои фото сцен, до 9": "Kendi sahne fotoğraflarınız, en fazla 9",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "Ürünü aynı sahnelerde çekeceğiz: arka plan, ışık, sunum. Ürünün kendisi değişmez",
    "Каждое фото даст один кадр": "Her fotoğraf bir kare verir",
    "не участвует в фотосессии товара": "ürün çekiminde yer almıyor",
    "Только для фотосессии товара": "Yalnızca ürün çekimi için",
    "Удалить из фотосессии товара": "Ürün çekiminden kaldır",
    "из фотосессии товара": "ürün çekiminden",
    "Сколько референсов, столько фото. Цена за кадр та же": "Referans sayısı kadar fotoğraf. Kare başı fiyat aynı",
    "Поиск сцен": "Sahne ara",
    "Нажмите, чтобы добавить сцену": "Sahne eklemek için dokunun"
  },
  "kk": {
    "сцена": "сахна",
    "сцены": "сахна",
    "сцен": "сахна",
    "Свой набор": "Өз жинағыңыз",
    "Модель ИИ": "ЖИ моделі",
    "Убираем фон · {0} из {1}": "Фонды алып тастаймыз · {1} ішінен {0}",
    "Фото {0} меньше {1} px по короткой стороне": "{0}-фото қысқа жағы бойынша {1} px-тен кіші",
    "Фон убран · сам товар не меняем": "Фон алынды · тауардың өзін өзгертпейміз",
    "Категория: {0}. Изменить": "Санат: {0}. Өзгерту",
    "· изменить": "· өзгерту",
    "По площадке": "Алаң бойынша",
    "{0} · под {1}": "{0} · {1} үшін",
    "поровну на сцены": "сахналарға тең бөлінеді",
    "{0} · без надписей на фото": "{0} · фотода жазусыз",
    "Например: мягкая тень, без реквизита": "Мысалы: жұмсақ көлеңке, реквизитсіз",
    "Без текста на фото": "Фотода мәтін жоқ",
    "Убираем фон, секунду": "Фонды алып тастаймыз, бір сәт",
    "Добавьте фото того, кто в кадре": "Кадрдағы адамның фотосын қосыңыз",
    "Сцены": "Сахналар",
    "Свой набор: выбрать до {0} сцен": "Өз жинағыңыз: {0} сахнаға дейін таңдаңыз",
    "Выбрать сцены": "Сахналарды таңдау",
    "До {0} сцен": "{0} сахнаға дейін",
    "Наборы": "Жинақтар",
    "Все сцены, {0}": "Барлық сахналар, {0}",
    "Модель ИИ: в наборе есть сцена с человеком": "ЖИ моделі: жинақта адамы бар сахна бар",
    "В наборе нужна хотя бы одна сцена": "Жинақта кемінде бір сахна болуы керек",
    "В одном наборе до {0} сцен": "Бір жинақта {0} сахнаға дейін",
    "Модель ИИ: в этой сцене есть человек": "ЖИ моделі: бұл сахнада адам бар",
    "Без модели: все кадры только с товаром": "Модельсіз: барлық кадрда тек тауар",
    "{0} в кадрах по вашим фото": "{0} сіздің фотоларыңыз бойынша кадрларда",
    "В сценах этой категории только товар, без людей": "Бұл санаттың сахналарында тек тауар, адамсыз",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "Жинақта адамы бар сахна жоқ: «Модельмен» немесе өз жинағыңызды таңдаңыз",
    "{0} во всех кадрах набора": "{0} жинақтың барлық кадрында",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0} {3} кадрдың {1} {2}, қалғанында тек тауар",
    "кадре": "кадрында",
    "кадрах": "кадрында",
    "Сцены с человеком убрали из набора": "Адамы бар сахналар жинақтан алынды",
    "Без модели: набор «Каталог»": "Модельсіз: «Каталог» жинағы",
    "Набор «С моделью»: в нём есть сцены с людьми": "«Модельмен» жинағы: онда адамы бар сахналар бар",
    "по {0} фото": "әрқайсысына {0} фото",
    "Искать среди {0} сцен · {1}": "{0} сахна ішінен іздеу · {1}",
    "Все сцены": "Барлық сахналар",
    "Сцена STEOS": "STEOS сахнасы",
    ". В кадре: {0}": ". Кадрда: {0}",
    "Пример {0}": "{0}-мысал",
    "О сцене": "Сахна туралы",
    "вы": "сіз",
    "модель ИИ": "ЖИ моделі",
    "Убрать из набора": "Жинақтан алып тастау",
    "Добавить в набор · {0}": "Жинаққа қосу · {0}",
    "Главный ракурс": "Негізгі ракурс",
    "Ракурс {0}": "{0}-ракурс",
    "убираем фон": "фонды алып тастаймыз",
    "фон убран": "фон алынды",
    "Без фона": "Фонсыз",
    "меньше": "кіші",
    "Сделать главным": "Негізгі ету",
    "Вырезка": "Қиынды",
    "Главное": "Негізгі",
    "Фото {0}: проверить вырезку": "{0}-фото: қиындыны тексеру",
    "Категория товара": "Тауар санаты",
    "Наборы и сцены под неё": "Оған арналған жинақтар мен сахналар",
    "Главное фото ·": "Негізгі фото ·",
    "фото {0} из {1}": "фото {0}/{1}",
    "{0}, фото {1}": "{0}, {1}-фото",
    "Ещё сцены": "Тағы сахналар",
    "модель: {0}": "модель: {0}",
    "без модели": "модельсіз",
    "Нужно фото товара: JPG или PNG": "Тауар фотосы керек: JPG немесе PNG",
    "Пожелания не прошли проверку": "Тілектер тексеруден өтпеді",
    "Не получилось снять товар": "Тауарды түсіру мүмкін болмады",
    "Изменить пожелания": "Тілектерді өзгерту",
    "Снимаем товар": "Тауарды түсіріп жатырмыз",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "Экраннан шығуға болады: жинақ дайын болғанда бот фотоларды чатқа жібереді.",
    "Фото товара готовы": "Тауар фотолары дайын",
    "Не удалось открыть экран. Попробуйте ещё раз.": "Экранды ашу мүмкін болмады. Қайта көріңіз.",
    "Загружаем сцены…": "Сахналар жүктелуде…",
    "Готовим файлы в формате «{0}»": "Файлдарды «{0}» пішімінде дайындаймыз",
    "Готовим файлы под {0}": "Файлдарды {0} үшін дайындаймыз",
    "Убираем фон": "Фонды алып тастаймыз",
    "Фон убран": "Фон алынды",
    "Снимаем сцены": "Сахналар түсірілуде",
    "Сцены сняты": "Сахналар түсірілді",
    "По вашим фото": "Сіздің фотоларыңыз бойынша",
    "{0} по вашим сценам": "{0} сіздің сахналарыңыз бойынша",
    "сцене": "сахнада",
    "сценах": "сахнада",
    "под {0}": "{0} үшін",
    "До 5 ракурсов, на любом фоне": "Кез келген фонда 5 ракурсқа дейін",
    "Свои фото сцен, до 9": "Өз сахна фотоларыңыз, 9-ға дейін",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "Тауарды дәл осындай сахналарда түсіреміз: фон, жарық, көрініс. Тауардың өзін өзгертпейміз",
    "Каждое фото даст один кадр": "Әр фото бір кадр береді",
    "не участвует в фотосессии товара": "тауар фотосессиясына қатыспайды",
    "Только для фотосессии товара": "Тек тауар фотосессиясы үшін",
    "Удалить из фотосессии товара": "Тауар фотосессиясынан жою",
    "из фотосессии товара": "тауар фотосессиясынан",
    "Сколько референсов, столько фото. Цена за кадр та же": "Референс қанша болса, фото сонша. Кадр бағасы бірдей",
    "Поиск сцен": "Сахналарды іздеу",
    "Нажмите, чтобы добавить сцену": "Сахна қосу үшін басыңыз"
  },
  "uk": {
    "сцена": "сцена",
    "сцены": "сцени",
    "сцен": "сцен",
    "Свой набор": "Власний набір",
    "Модель ИИ": "Модель ШІ",
    "Убираем фон · {0} из {1}": "Прибираємо фон · {0} з {1}",
    "Фото {0} меньше {1} px по короткой стороне": "Фото {0} менше за {1} px за коротшою стороною",
    "Фон убран · сам товар не меняем": "Фон прибрано · сам товар не змінюємо",
    "Категория: {0}. Изменить": "Категорія: {0}. Змінити",
    "· изменить": "· змінити",
    "По площадке": "За майданчиком",
    "{0} · под {1}": "{0} · під {1}",
    "поровну на сцены": "порівну на сцени",
    "{0} · без надписей на фото": "{0} · без написів на фото",
    "Например: мягкая тень, без реквизита": "Наприклад: м’яка тінь, без реквізиту",
    "Без текста на фото": "Без тексту на фото",
    "Убираем фон, секунду": "Прибираємо фон, секунду",
    "Добавьте фото того, кто в кадре": "Додайте фото того, хто в кадрі",
    "Сцены": "Сцени",
    "Свой набор: выбрать до {0} сцен": "Власний набір: оберіть до {0} сцен",
    "Выбрать сцены": "Обрати сцени",
    "До {0} сцен": "До {0} сцен",
    "Наборы": "Набори",
    "Все сцены, {0}": "Усі сцени, {0}",
    "Модель ИИ: в наборе есть сцена с человеком": "Модель ШІ: у наборі є сцена з людиною",
    "В наборе нужна хотя бы одна сцена": "У наборі потрібна хоча б одна сцена",
    "В одном наборе до {0} сцен": "В одному наборі до {0} сцен",
    "Модель ИИ: в этой сцене есть человек": "Модель ШІ: у цій сцені є людина",
    "Без модели: все кадры только с товаром": "Без моделі: усі кадри лише з товаром",
    "{0} в кадрах по вашим фото": "{0} у кадрах за вашими фото",
    "В сценах этой категории только товар, без людей": "У сценах цієї категорії лише товар, без людей",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "У наборі немає сцен з людьми: оберіть «З моделлю» або власний набір",
    "{0} во всех кадрах набора": "{0} в усіх кадрах набору",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0} у {1} {2} з {3}, решта лише з товаром",
    "кадре": "кадрі",
    "кадрах": "кадрах",
    "Сцены с человеком убрали из набора": "Сцени з людиною прибрали з набору",
    "Без модели: набор «Каталог»": "Без моделі: набір «Каталог»",
    "Набор «С моделью»: в нём есть сцены с людьми": "Набір «З моделлю»: у ньому є сцени з людьми",
    "по {0} фото": "по {0} фото",
    "Искать среди {0} сцен · {1}": "Шукати серед {0} сцен · {1}",
    "Все сцены": "Усі сцени",
    "Сцена STEOS": "Сцена STEOS",
    ". В кадре: {0}": ". У кадрі: {0}",
    "Пример {0}": "Приклад {0}",
    "О сцене": "Про сцену",
    "вы": "ви",
    "модель ИИ": "модель ШІ",
    "Убрать из набора": "Прибрати з набору",
    "Добавить в набор · {0}": "Додати до набору · {0}",
    "Главный ракурс": "Головний ракурс",
    "Ракурс {0}": "Ракурс {0}",
    "убираем фон": "прибираємо фон",
    "фон убран": "фон прибрано",
    "Без фона": "Без фону",
    "меньше": "менше",
    "Сделать главным": "Зробити головним",
    "Вырезка": "Вирізка",
    "Главное": "Головне",
    "Фото {0}: проверить вырезку": "Фото {0}: перевірити вирізку",
    "Категория товара": "Категорія товару",
    "Наборы и сцены под неё": "Набори й сцени під неї",
    "Главное фото ·": "Головне фото ·",
    "фото {0} из {1}": "фото {0} з {1}",
    "{0}, фото {1}": "{0}, фото {1}",
    "Ещё сцены": "Ще сцени",
    "модель: {0}": "модель: {0}",
    "без модели": "без моделі",
    "Нужно фото товара: JPG или PNG": "Потрібне фото товару: JPG або PNG",
    "Пожелания не прошли проверку": "Побажання не пройшли перевірку",
    "Не получилось снять товар": "Не вдалося зняти товар",
    "Изменить пожелания": "Змінити побажання",
    "Снимаем товар": "Знімаємо товар",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "Можна піти з екрана: бот надішле фото в чат, щойно набір буде готовий.",
    "Фото товара готовы": "Фото товару готові",
    "Не удалось открыть экран. Попробуйте ещё раз.": "Не вдалося відкрити екран. Спробуйте ще раз.",
    "Загружаем сцены…": "Завантажуємо сцени…",
    "Готовим файлы в формате «{0}»": "Готуємо файли у форматі «{0}»",
    "Готовим файлы под {0}": "Готуємо файли під {0}",
    "Убираем фон": "Прибираємо фон",
    "Фон убран": "Фон прибрано",
    "Снимаем сцены": "Знімаємо сцени",
    "Сцены сняты": "Сцени знято",
    "По вашим фото": "За вашими фото",
    "{0} по вашим сценам": "{0} за вашими сценами",
    "сцене": "сцені",
    "сценах": "сценах",
    "под {0}": "під {0}",
    "До 5 ракурсов, на любом фоне": "До 5 ракурсів, на будь-якому тлі",
    "Свои фото сцен, до 9": "Власні фото сцен, до 9",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "Знімемо товар у таких самих сценах: фон, світло, подача. Сам товар не змінюємо",
    "Каждое фото даст один кадр": "Кожне фото дасть один кадр",
    "не участвует в фотосессии товара": "не бере участі у фотосесії товару",
    "Только для фотосессии товара": "Лише для фотосесії товару",
    "Удалить из фотосессии товара": "Видалити з фотосесії товару",
    "из фотосессии товара": "з фотосесії товару",
    "Сколько референсов, столько фото. Цена за кадр та же": "Скільки референсів, стільки фото. Ціна за кадр та сама",
    "Поиск сцен": "Пошук сцен",
    "Нажмите, чтобы добавить сцену": "Натисніть, щоб додати сцену"
  },
  "zh": {
    "сцена": "场景",
    "сцены": "场景",
    "сцен": "场景",
    "Свой набор": "自选组合",
    "Модель ИИ": "AI 模特",
    "Убираем фон · {0} из {1}": "正在去除背景 · {0} / {1}",
    "Фото {0} меньше {1} px по короткой стороне": "照片 {0} 短边小于 {1} px",
    "Фон убран · сам товар не меняем": "背景已去除 · 商品本身不变",
    "Категория: {0}. Изменить": "类别：{0}。修改",
    "· изменить": "· 修改",
    "По площадке": "按平台格式",
    "{0} · под {1}": "{0} · 适用于 {1}",
    "поровну на сцены": "平均分配到各场景",
    "{0} · без надписей на фото": "{0} · 照片上无文字",
    "Например: мягкая тень, без реквизита": "例如：柔和阴影，无道具",
    "Без текста на фото": "照片上无文字",
    "Убираем фон, секунду": "正在去除背景，请稍候",
    "Добавьте фото того, кто в кадре": "添加画面中人物的照片",
    "Сцены": "场景",
    "Свой набор: выбрать до {0} сцен": "自选组合：最多选择 {0} 个场景",
    "Выбрать сцены": "选择场景",
    "До {0} сцен": "最多 {0} 个场景",
    "Наборы": "组合",
    "Все сцены, {0}": "全部场景，{0}",
    "Модель ИИ: в наборе есть сцена с человеком": "AI 模特：组合中有含人物的场景",
    "В наборе нужна хотя бы одна сцена": "组合中至少需要一个场景",
    "В одном наборе до {0} сцен": "一个组合最多 {0} 个场景",
    "Модель ИИ: в этой сцене есть человек": "AI 模特：此场景中有人物",
    "Без модели: все кадры только с товаром": "无模特：所有画面只有商品",
    "{0} в кадрах по вашим фото": "{0} 出现在根据你照片生成的画面中",
    "В сценах этой категории только товар, без людей": "此类别的场景只有商品，没有人物",
    "В наборе нет сцен с людьми: выберите «С моделью» или свой набор": "组合中没有含人物的场景：请选择「含模特」或自选组合",
    "{0} во всех кадрах набора": "{0} 出现在组合的所有画面中",
    "{0} в {1} {2} из {3}, остальные только с товаром": "{0} 出现在 {3} 个{2}中的 {1} 个里，其余只有商品",
    "кадре": "画面",
    "кадрах": "画面",
    "Сцены с человеком убрали из набора": "含人物的场景已从组合中移除",
    "Без модели: набор «Каталог»": "无模特：「目录」组合",
    "Набор «С моделью»: в нём есть сцены с людьми": "「含模特」组合：其中有含人物的场景",
    "по {0} фото": "每个 {0} 张照片",
    "Искать среди {0} сцен · {1}": "在 {0} 个场景中搜索 · {1}",
    "Все сцены": "全部场景",
    "Сцена STEOS": "STEOS 场景",
    ". В кадре: {0}": "。画面中：{0}",
    "Пример {0}": "示例 {0}",
    "О сцене": "关于场景",
    "вы": "你",
    "модель ИИ": "AI 模特",
    "Убрать из набора": "从组合中移除",
    "Добавить в набор · {0}": "加入组合 · {0}",
    "Главный ракурс": "主角度",
    "Ракурс {0}": "角度 {0}",
    "убираем фон": "正在去除背景",
    "фон убран": "背景已去除",
    "Без фона": "无背景",
    "меньше": "小于",
    "Сделать главным": "设为主图",
    "Вырезка": "抠图",
    "Главное": "主图",
    "Фото {0}: проверить вырезку": "照片 {0}：检查抠图",
    "Категория товара": "商品类别",
    "Наборы и сцены под неё": "适用的组合和场景",
    "Главное фото ·": "主照片 ·",
    "фото {0} из {1}": "照片 {0} / {1}",
    "{0}, фото {1}": "{0}，照片 {1}",
    "Ещё сцены": "更多场景",
    "модель: {0}": "模特：{0}",
    "без модели": "无模特",
    "Нужно фото товара: JPG или PNG": "需要商品照片：JPG 或 PNG",
    "Пожелания не прошли проверку": "要求未通过审核",
    "Не получилось снять товар": "商品拍摄失败",
    "Изменить пожелания": "修改要求",
    "Снимаем товар": "正在拍摄商品",
    "Можно уйти с экрана: бот пришлёт фото в чат, как только набор будет готов.": "可以离开此页面：组合完成后机器人会把照片发到聊天中。",
    "Фото товара готовы": "商品照片已完成",
    "Не удалось открыть экран. Попробуйте ещё раз.": "无法打开页面，请重试。",
    "Загружаем сцены…": "正在加载场景…",
    "Готовим файлы в формате «{0}»": "正在准备「{0}」格式的文件",
    "Готовим файлы под {0}": "正在准备适用于 {0} 的文件",
    "Убираем фон": "正在去除背景",
    "Фон убран": "背景已去除",
    "Снимаем сцены": "正在拍摄场景",
    "Сцены сняты": "场景已拍完",
    "По вашим фото": "根据你的照片",
    "{0} по вашим сценам": "{0} 出现在你的场景中",
    "сцене": "场景",
    "сценах": "场景",
    "под {0}": "适用于 {0}",
    "До 5 ракурсов, на любом фоне": "最多 5 个角度，任意背景",
    "Свои фото сцен, до 9": "自己的场景照片，最多 9 张",
    "Товар снимем в таких же сценах: фон, свет, подача. Сам товар не меняем": "商品将在同样的场景中拍摄：背景、光线、呈现方式。商品本身不变",
    "Каждое фото даст один кадр": "每张照片生成一个画面",
    "не участвует в фотосессии товара": "不参与商品写真",
    "Только для фотосессии товара": "仅用于商品写真",
    "Удалить из фотосессии товара": "从商品写真中移除",
    "из фотосессии товара": "从商品写真中",
    "Сколько референсов, столько фото. Цена за кадр та же": "参考图有几张，就生成几张照片。每个画面价格不变",
    "Поиск сцен": "搜索场景",
    "Нажмите, чтобы добавить сцену": "点击添加场景"
  }
}
